module.exports = __webpack_public_path__ + "img/Bar-chart-icon.d7892ce6.svg";